import { useUpsellFlows } from '@hooks';
import React from 'react';

import { AddUpselFlowModal } from './AddUpsellFlowModal/Add.upselFlow';
import { FilterUpsellFlows } from './Filter.upsellFlows';
import { TableUpsellFlows } from './Table.upsellFlows';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const UpsellFlows: React.FC = () => {
  const {
    upsellList,
    isLoadingData,
    handleChangePagination,
    handleEditUpsellFlow,
    handleFilterUpsellFlow,
    pageSize,
    addModal,
  } = useUpsellFlows();

  const {
    handleCloseAddModal,
    handleSuccessAddModal,
    handleOpenAddModal,
    isOpenAddModal,
  } = addModal;
  return (
    <>
      <TableUpsellFlows
        filterComponent={
          <FilterUpsellFlows
            onFilterUpsellFlows={handleFilterUpsellFlow}
            onAddUpsellFlows={handleOpenAddModal}
          />
        }
        onChangePagination={handleChangePagination}
        data={upsellList}
        onEditUpsellFlow={handleEditUpsellFlow}
        isLoading={isLoadingData}
        pageSize={pageSize}
      />
      <AddUpselFlowModal
        onCloseModal={handleCloseAddModal}
        modalIsOpen={isOpenAddModal}
        onSuccess={handleSuccessAddModal}
      />
    </>
  );
};
